import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
const control = 'w-full rounded-xl border bg-white px-4 py-3 text-[15px] text-ink placeholder:text-ink-faint transition-colors duration-200 ease-smooth focus:outline-none';
const normal = 'border-line hover:border-ink/25 focus:border-accent';
const invalid = 'border-danger focus:border-danger';
interface BaseProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  className?: string;
  id: string;
}
function Wrapper({
  label,
  hint,
  error,
  required,
  id,
  className = '',
  children
}: BaseProps & {
  children: React.ReactNode;
}) {
  return <div className={className} data-id="element-417" data-mp="hv2zn2v5hsjt">
      <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-ink" data-id="element-418" data-mp="hw4c9brten3n">
        {label}
        {required && <span className="ml-1 text-accent" data-id="element-419" data-mp="rrxyjmvc5uym">*</span>}
      </label>
      {children}
      {error ? <p className="mt-1.5 text-xs font-medium text-danger" data-id="element-420" data-mp="wr27cceclqof">{error}</p> : hint && <p className="mt-1.5 text-xs text-ink-muted" data-id="element-421" data-mp="woofsdivmwlm">{hint}</p>}
    </div>;
}
export function TextField({
  label,
  hint,
  error,
  required,
  className,
  id,
  ...rest
}: BaseProps & React.InputHTMLAttributes<HTMLInputElement>) {
  return <Wrapper label={label} hint={hint} error={error} required={required} id={id} className={className} data-id="element-422" data-mp="oe1gnii9kepf">
      <input id={id} required={required} aria-invalid={error ? true : undefined} className={`${control} ${error ? invalid : normal} ${rest.disabled || rest.readOnly ? 'cursor-not-allowed bg-canvas text-ink-soft' : ''}`} {...rest} data-id="element-423" data-mp="kczoflmrl2wy" />
    </Wrapper>;
}
export function TextArea({
  label,
  hint,
  error,
  required,
  className,
  id,
  rows = 5,
  ...rest
}: BaseProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <Wrapper label={label} hint={hint} error={error} required={required} id={id} className={className} data-id="element-424" data-mp="1ztzwc57y5yzm">
      <textarea id={id} rows={rows} required={required} aria-invalid={error ? true : undefined} className={`${control} ${error ? invalid : normal} resize-y`} {...rest} data-id="element-425" data-mp="1v05cn1scdk0j" />
    </Wrapper>;
}
export function SelectField({
  label,
  hint,
  error,
  required,
  className,
  id,
  options,
  ...rest
}: BaseProps & React.SelectHTMLAttributes<HTMLSelectElement> & {
  options: {
    value: string;
    label: string;
  }[];
}) {
  return <Wrapper label={label} hint={hint} error={error} required={required} id={id} className={className} data-id="element-426" data-mp="36i9pbsgk3ack">
      <div className="relative" data-id="element-427" data-mp="3bjqnhg7noipg">
        <select id={id} required={required} className={`${control} ${error ? invalid : normal} appearance-none pr-10`} {...rest} data-id="element-428" data-mp="3bft3ksd97n4i">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-429" data-mp="utry93kqt6zp">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-faint" aria-hidden="true" data-id="element-430" data-mp="zrbnszmw566y" />
      </div>
    </Wrapper>;
}